import getConfig from 'next/config'
import axios from 'axios'

const updateToken = (client, token) => {
  client.options.headers.authorization = token
}

const userAuthRest = async (path, options = { mode: 'cors' }) => {
  const { data } = await axios(`/api${path}`, options)
  return data
}

const productsRest = async (path, options) => {
  const { data } = await axios(`/api${path}`, options)
  return data
}

const ordersRest = async (path, options) => {
  const { data } = await axios(`/api${path}`, options)
  return data;
}

const localRest = async (path, options) => {
  const { data } = await axios(`/api${path}`, options)
  return data
}

export { updateToken, userAuthRest, productsRest, ordersRest, localRest }
